import { render, staticRenderFns } from "./PlatformHeader.vue?vue&type=template&id=39060ade&scoped=true"
import script from "./PlatformHeader.vue?vue&type=script&lang=js"
export * from "./PlatformHeader.vue?vue&type=script&lang=js"
import style0 from "./PlatformHeader.vue?vue&type=style&index=0&id=39060ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39060ade",
  null
  
)

export default component.exports